import { ReactComponent as CheckmarkIcon } from "assets/icons/checkmark.svg";
import { ReactComponent as CheckmarkCirclePurple } from "assets/icons/checkmark-circle-purple.svg";
import { ReactComponent as CheckmarkCircleLight } from "assets/icons/checkmark-circle-light.svg";
import { ReactComponent as CheckmarkCircleOutlinePurple } from "assets/icons/checkmark-circle-outline-purple.svg";
import { cx } from "utils";
import { ReactNode } from 'react';


interface ICheckedComponentProps {
  className?: string;
  children?: ReactNode;
  variant?: 'default' | 'circle' | 'outline';
  highlighted?: boolean;
  iconSize?: string;
}

export default function CheckedComponent({
  className,
  children,
  variant = 'default',
  highlighted = false,
  iconSize = 'w-6 h-6',
}: ICheckedComponentProps) {

  if (variant === 'outline') {
    return (
      <div className={cx(className, "flex gap-x-2 items-center")}>
        <CheckmarkCircleOutlinePurple className={`${iconSize} flex-shrink-0`} />
        <span>{children}</span>
      </div>
    );
  }

  if (variant === 'circle') {
    const CheckIcon = highlighted ? CheckmarkCirclePurple : CheckmarkCircleLight;

    return (
      <div className={cx(className, "flex gap-x-2 items-center")}>
        <CheckIcon className={`${iconSize} flex-shrink-0`} />
        <span>{children}</span>
      </div>
    );
  }

  return (
    <div className={cx(className, "flex gap-x-4")}>
      <span><CheckmarkIcon className="h-full"/></span>
      <span>{children}</span>
    </div>
  );
};
